module.exports = __webpack_public_path__ + "img/gb9121_6_b.prt.f45eb68f.jpg";